import { Icon, Link } from "@wdpr/groot-components";

const mainClass = "syndicated-navigation__chrome__links__container";

const ChromeLinks = ({ brand = "", elements = [], mobileIcon = "", cdnAssetsUrl }) => {
	if (!elements.length) {
		return null;
	}

	return elements.map((element, key) => (
		<div className={`${mainClass} ${mainClass}--${brand}`} key={key}>
			{element.link && (
				<Link className={`${mainClass}__link`} {...element.link} />
			)}
			{element.descriptions?.[0] && (
				<>
					{mobileIcon && <Icon icon={mobileIcon} cdnUrl={cdnAssetsUrl} />}
					<span
						dangerouslySetInnerHTML={{ __html: element.descriptions[0].title }}
						className={`${mainClass}__description`}
					/>
				</>
			)}
		</div>
	));
};

export default ChromeLinks;
